import { createTheme } from '@mui/material/styles';
import { APP_ENV } from './consts';

export const getPrimaryColor = () => {
    switch (APP_ENV) {
        case 'crest':
            return '#1673b8'; // '#418dc1' '#0a6db7'
        case 'puppet-interview':
            return '#ef6c00';
        default:
            return '#8e24aa';
    }
};

export const getSecondaryColor = () => {
    switch (APP_ENV) {
        case 'crest':
            return '#002047';
        case 'puppet-interview':
            return '#0d0638';
        default:
            return '#0d0638';
    }
};

export const getTransparentColor = (color: string, transparency: number): string =>
    `${color}${transparency <= 1 ? Math.round(transparency * 100) : Math.round(transparency)}`;

export default createTheme({
    palette: {
        primary: { main: getPrimaryColor(), light: getTransparentColor(getPrimaryColor(), 0.1) },
        secondary: {
            main: getSecondaryColor(),
            light: getTransparentColor(getSecondaryColor(), 0.5),
        },
    },
    components: {
        MuiTooltip: {
            styleOverrides: {
                tooltip: { backgroundColor: 'rgba(0, 0, 0, 0.8)', fontSize: '1rem' },
            },
        },
    },
});
